import api from '@/libs/api'
import store from '@/store'

const organizationId = () => store.state.app.organizationId

export default {
  namespaced: true,
  state: {
    loading: false,
    roles: [],
    role: null,
    resultInfo: null,
    currentPage: 1,
    fetchingRoles: false,
    addingRole: false,
    gettingRole: false,
    updatingRole: false,
    removingRole: false,
    permissions: [],
    permissionsResultInfo: null,
    selectedPermissions: [],
    fetchingPermissions: false,
    invitingUser: false,
  },
  getters: {
    selectedPermissions: state => state.selectedPermissions,
    currentPage: state => state.currentPage,
  },
  mutations: {
    SET_ROLES(state, data) {
      state.roles = data.result
      state.resultInfo = data.resultInfo
    },
    GET_ROLE(state, role) {
      state.role = role
    },
    SET_FETCHING_ROLES(state, value) {
      state.fetchingRoles = value
    },
    SET_GETTING_ROLE(state, value) {
      state.gettingRole = value
    },
    SET_ADDING_ROLE(state, value) {
      state.addingRole = value
    },
    SET_UPDATING_ROLE(state, value) {
      state.updatingRole = value
    },
    SET_REMOVING_ROLE(state, value) {
      state.removingRole = value
    },
    SET_PERMISSIONS(state, data) {
      state.permissions = data.result
      state.permissionsResultInfo = data.resultInfo
    },
    SET_SELECTED_PERMISSIONS(state, data) {
      state.selectedPermissions = data
    },
    SET_FETCHING_PERMISSIONS(state, value) {
      state.fetchingPermissions = value
    },
    SET_INVITING_USER(state, value) {
      state.invitingUser = value
    },
    SET_CURRENT_PAGE(state, id) {
      state.currentPage = id
    },
    REMOVE_ROLE(state, id) {
      state.roles = state.roles.filter(r => r.id !== id)
    },
  },
  actions: {
    fetchRoles({ commit }, query) {
      commit('SET_FETCHING_ROLES', true)
      return new Promise((resolve, reject) => {
        api('captain').get(`/organizations/${organizationId()}/roles?PageIndex=${query.pageIndex}&PageSize=${query.pageSize}`)
          .then(response => {
            commit('SET_ROLES', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_ROLES', false) })
      })
    },
    getRole({ commit }, roleId) {
      commit('SET_GETTING_ROLE', true)
      return new Promise((resolve, reject) => {
        api('captain').get(`/organizations/${organizationId()}/roles/${roleId}`)
          .then(response => {
            commit('GET_ROLE', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_ROLE', false) })
      })
    },
    addRole({ commit }, role) {
      commit('SET_ADDING_ROLE', true)
      return new Promise((resolve, reject) => {
        api('captain').post(`/organizations/${organizationId()}/roles/`, role)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_ROLE', false) })
      })
    },
    updateRole({ commit }, query) {
      commit('SET_UPDATING_ROLE', true)
      return new Promise((resolve, reject) => {
        api('captain').put(`/organizations/${organizationId()}/roles/${query.id}`, query.role)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_ROLE', false) })
      })
    },
    deleteRole({ commit }, roleId) {
      commit('SET_REMOVING_ROLE', true)
      return new Promise((resolve, reject) => {
        api('captain').delete(`/organizations/${organizationId()}/roles/${roleId}`)
          .then(response => {
            commit('REMOVE_ROLE', roleId)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_ROLE', false) })
      })
    },
    inviteUser({ commit }, user) {
      commit('SET_INVITING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain').post(`/organizations/${organizationId()}/users`, user)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_INVITING_USER', false) })
      })
    },
    fetchPermissions({ commit }, query) {
      commit('SET_FETCHING_PERMISSIONS', true)
      let url = `/permissions?PageIndex=${query.pageIndex}&PageSize=${query.pageSize}`
      if (query.role) {
        url += `&Role=${query.role}`
      }
      if (query.search) {
        url += `&Search=${query.search}`
      }
      return new Promise((resolve, reject) => {
        api('captain').get(url)
          .then(response => {
            commit('SET_PERMISSIONS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_PERMISSIONS', false) })
      })
    },
  },
}
